module.exports = __webpack_public_path__ + "img/acreditacion_4.a46fef26.png";